import React from "react"
import { Link } from 'gatsby'

export default function PostContentHeader({ categoryName, postTitle, location }) {
  let from = false

  if (location?.state?.from) {
    from = location.state.from
    from = from.replace('/magazine', '')
  }

  return (
    <section id="content-header">
      <div className="page-title">
        {
          (from) ? (
            <Link to={from} className="back-button">←</Link>
          ) : (
            <Link to="/" className="back-button">←</Link>
          )
        }
        <div className="category-title">
          <p className="category">{categoryName}</p>
          <p className="title">{postTitle}</p>
        </div>
      </div>
    </section>
  )
}




